import React from 'react'
import PropTypes from 'prop-types'

class Message extends React.Component {

  render() {
    return (
      <React.Fragment>
        <div className="mb-4">
          {this.props.question.message}
        </div>
      </React.Fragment>
    );
  }
}

Message.propTypes = {
  question: PropTypes.object.isRequired,
}

export default Message
